import { Input } from "common/InputForm";
import useButtonLoader from "common/UseButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { useState } from "react";
import { addBrandApi } from "services/brand";
import { toastMessage } from "utils/toastMessage";

export const AddBrandModel = ({ setAddModal, addModal, brandListHandler }) => {
  const [errors, setErrors] = useState({});
  const [inputData, setInputData] = useState({
    name: "",
    logo: "",
    brandType: "",
  });
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Add");
  const validation = () => {
    let isValid = true;
    const error = {};

    if (!inputData.name) {
      error["name"] = "Please enter a Brand name";
      isValid = false;
    }

    if (!inputData.brandType) {
      error["brandType"] = "Please select a Brand Type";
      isValid = false;
    }
    if (!inputData.logo) {
      error["logo"] = "Please select logo";
      isValid = false;
    }
    if (!inputData.orderNumber) {
      error["orderNumber"] = "Please select orderNumber";
      isValid = false;
    }

    setErrors(error);
    return isValid;
  };
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };
  const addBrand = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoaders(true);
      try {
        const formData = new FormData();
        formData.append("name", inputData.name);
        formData.append("orderNumber", inputData.orderNumber);
        formData.append("logo", inputData.logo);
        formData.append("brandType", inputData.brandType);

        const res = await addBrandApi(formData);
        if (res?.data?.status === 200) {
          toastMessage(res?.data?.message, "success", "addBrand");
          setInputData({ name: "", logo: "", brandType: "" });
          setAddModal(false);
          brandListHandler();
        } else {
          toastMessage(res?.data?.message, "error", "addBrand");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoaders(false);
      }
    }
  };
  const filesHandler = (e) => {
    const file = e.target.files[0];
    const filePreviewUrl = URL.createObjectURL(file);
    setInputData((prevState) => ({
      ...prevState,
      logo: file,
      logoPreview: filePreviewUrl,
    }));
    setErrors({
      ...errors,
      logo: null,
    });
  };
  return (
    <CustomModal
      className={"add_model"}
      show={addModal}
      handleClose={() => {
        setAddModal(false);
        setInputData({ name: "", logo: "", brandType: "" });
        setErrors({});
      }}
    >
      <h3>Add Brand</h3>
      <div className="add_model">
        <div className="form_field_wrap">
          {/* Brand Name */}
          <div className="form_field">
            <Input
              className={"form-control input"}
              label={"Brand Name"}
              type={"text"}
              value={inputData.name || ""}
              onChange={onChangeHandler}
              placeholder={"Enter Brand Name"}
              name={"name"}
              error={errors?.name}
            />
          </div>
          {/* Brand Type */}
          <div className="form_field">
            <label className="label">Brand Type</label>
            <select
              className="form-control input"
              name="brandType"
              value={inputData.brandType}
              onChange={onChangeHandler}
            >
              <option value="">Select Brand Type</option>
              <option value="Value fashion">Value fashion</option>
              <option value="High street">High street</option>
              <option value="Premium">Premium</option>
              <option value="High end">High end</option>
            </select>
            {errors?.brandType && (
              <span className="error">{errors.brandType}</span>
            )}
          </div>
        </div>

        {/* Logo */}
        <div className="form_field">
        <label className="label">Logo</label>
          <Input
            type="file"
            id="logo_image"
            accept="image/*"
            onChange={(e) => filesHandler(e)}
            error={errors.logo}
          />
          <label htmlFor="logo_image"></label>

          {inputData?.logoPreview ? (
            <>
              <div className="image_preview">
                <img
                  src={inputData?.logoPreview}
                  alt="Logo Preview"
                  className="logo_preview"
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </div>

        <div className="form_field">
          <Input
            className={"form-control input"}
            label={"Order Number"}
            type={"number"}
            value={inputData.orderNumber || ""}
            onChange={onChangeHandler}
            placeholder={"Enter Order Number"}
            name={"orderNumber"}
            error={errors?.orderNumber}
          />
        </div>
      </div>

      <div className="button_wrap">
        <button
          type="button"
          className="button light"
          onClick={() => setAddModal(false)}
        >
          Cancel
        </button>
        <button
          type="button"
          ref={buttonLoaders}
          onClick={addBrand}
          className="button"
        >
          Submit
        </button>
      </div>
    </CustomModal>
  );
};
